// eslint-disable-next-line import/prefer-default-export
export const ns = (namespace, type) => `${namespace}/${type}`;
